module.exports = __webpack_public_path__ + "0af5d249/img/file-icon.c085e21e.svg";